module.exports = __webpack_public_path__ + "static/media/profile-13.fe16ee04.png";